export default __webpack_public_path__ + "static/Plots0001-ec941cf564e42856ce50bbdfe2fc558e.jpg";